<template>
    <section class="p-5 card log-panel col-xl-4 offset-xl-4 col-md-6 offset-md-3 col-10 offset-1 mt-md-0 mt-1">

        <h5 class="text-center">تقارير عامة</h5>
        <form @submit.prevent="getReport" class=" my-3">
            <div class="mb-3">
                <label for="from" class="form-label">من : </label>
                <input type="date" v-model="searchData.from" id="from" class="form-control" placeholder=""
                    aria-describedby="from-date" />
                <small id="from-date" class="text-muted">من تاريخ</small>
            </div>
            <div class="mb-3">
                <label for="to" class="form-label">إلى : </label>
                <input type="date" v-model="searchData.to" id="to" class="form-control" placeholder=""
                    aria-describedby="to-date" />
                <small id="to-date" class="text-muted">إلى تاريخ</small>
            </div>
            <div class="container justify-content-center">
                <div class="my-2" >
                    <label for="report-type" class="form-label">نوع التقرير</label>
                    <select class="form-select" id="report-type" v-model="searchData.type"
                        @change="resetValues()" required="required" >
                        <!-- <option selected disabled>{{ field.placeholder }}</option> -->
                        <option selected value="1">
                            تقرير حسب حالة الطلب
                        </option>
                        <option value="2">
                           تقرير حسب نوع المركبة
                        </option>
                        <option value="3">
                           تقرير حركة المركبات اليومية
                        </option>
                        
                    </select>
                </div>

                <div v-if="searchData.type == 1" class="radio-choices my-2">
                    
                    <h6 >اختر حالة الطلبات</h6>
                    <div class="form-check form-check-inline">
                        <input v-model="searchData.status" class="form-check-input" type="radio" id="search-app" value="1"
                            checked @change="resetValues()" />
                        <label class="form-check-label" for="search-app">الطلبات المقدمة</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="searchData.status" class="form-check-input" type="radio" id="search-accepted"
                            value="2" @change="resetValues()" />
                        <label class="form-check-label" for="search-accepted">المركبات المغادرة</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="searchData.status" class="form-check-input" type="radio" id="search-arrived"
                            value="3" @change="resetValues()" />
                        <label class="form-check-label" for="search-arrived">المركبات العائدة</label>
                    </div>
                </div>
                
                <div v-else-if="searchData.type == 2" class="select-choices my-2">
                    <label for="trans-type" class="form-label">نوع المركبة</label>
                    <select class="form-select" id="trans-type" v-model="searchData.transType"
                        required="required" >
                        <option selected disabled>اختر نوع المركبة</option>
                        <option v-for="trans in getTransTypes" :key="trans.id" :value="trans.id">
                            {{trans.name}}
                        </option>
                    </select>
                </div>
                <div v-else-if="searchData.type == 3" class="radio-choices my-2">
                    
                    <h6 >اختر حالة الطلبات</h6>
                    <div class="form-check form-check-inline">
                        <input v-model="searchData.status" class="form-check-input" type="radio" id="search-total" value="0"
                            @change="resetValues()" />
                        <label class="form-check-label" for="search-total">إجمالي حركة البوابات</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="searchData.status" class="form-check-input" type="radio" id="search-departure"
                            value="1" @change="resetValues()" />
                        <label class="form-check-label" for="search-departure">تعداد المغادرين (دخول و خروج)</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input v-model="searchData.status" class="form-check-input" type="radio" id="search-arrived"
                            value="2" @change="resetValues()" />
                        <label class="form-check-label" for="search-arrived">تعداد العائدين (إلى ليبيا و إلى خارج ليبيا)</label>
                    </div>
                </div>
                
                <div class="" v-if="(getUser?.departId == 1)">
                    <label for="departId" class="form-label">المركز الجمركي</label>
                    <select class="form-select" id="departId" v-model="searchData['departId']" @change="resetValues()"
                        required="required">
                        <option value="" data-hidden="true" selected disabled>
                            اختر المركز الجمركي
                        </option>
                        <option v-for="depart in departs" :key="depart.id" :value="depart.id">
                            {{ depart.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div v-if="searchData.type != 3" class="container justify-content-center mt-3">
                
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-export"
                        value="1" @change="resetValues()" />
                    <label class="form-check-label" for="search-export">التصدير المؤقت</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-import"
                        value="2" @change="resetValues()" />
                    <label class="form-check-label" for="search-import">الاستيراد المؤقت</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-any" value="0"
                        @change="resetValues()" />
                    <label class="form-check-label" for="search-any">الكل</label>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-2">
                <button class="btn btn-primary " type="submit">بحث</button>
                <button @click="$router.go(-1)" class="btn btn-secondary " type="button">عودة
                    <font-awesome-icon icon="fa-regular fa-circle-left" />
                </button>
            </div>
            <!-- <button class="btn btn-secondary mt-2 offset-10" type="submit">بحث</button> -->
        </form>
    </section>
    <ApplicantStatusReport v-if="searchData.type == 1" :reportData="reportData" :depart="departs.find(e => e.id === reportData.departId)?.name"/>
    <TransTypeReport v-else-if="searchData.type == 2" :reportData="reportData" :depart="departs.find(e => e.id === reportData.departId)?.name"/>
    <DailyTrafficReport v-else-if="searchData.type == 3" :reportData="reportData" :depart="departs.find(e => e.id === reportData.departId)?.name" :status="searchData.status"/>
    
</template>

<script>
import GeneralModal from "@/components/Modal.vue";
import AlertModal from "@/components/AlertModal.vue";
import { mapGetters, mapActions } from 'vuex';
import ApplicantStatusReport from "@/components/GeneralReports/ApplicantStatusReport.vue";
import TransTypeReport from "@/components/GeneralReports/TransTypeReport.vue";
import DailyTrafficReport from "@/components/GeneralReports/DailyTrafficReport.vue";
export default {
    name: "generalReport",
    components: {
        GeneralModal,
        AlertModal,
        ApplicantStatusReport,
        TransTypeReport,
        DailyTrafficReport
    },
    data() {
        return {
            searchData: {
                from: null,
                to: null,
                type: 1,
                status: 1,
                transType: 0,
                appType: 0,
                pageNo: 1,
                pageSize: 25,
            },
            departs: [],
            reportData: {},
            // keyDateText: ["", "التقديم", "المغادرة", "العودة"]
            endPoints: [
                    '',
                    'api/employee/report/getappsbystatus',
                    'api/employee/report/getappsbytrans',
                    'api/employee/report/getdailytraffic'
                ],
            printEndPoints: [
                    '',
                    'api/employee/report/getappsbystatus/print',
                    'api/employee/report/getappsbytrans/print',
                    'api/employee/report/getdailytraffic/print'
                ]
        }
    },
    async created() {
        this.setDates();
        await this.fetchOptions();
    },
    computed: {
        ...mapGetters(['getUser', 'getDeparts', 'getTransTypes']),
        currentCountInView : function(){
            return this.searchData?.pageSize * this.searchData?.pageNo;
        }
    },
    methods: {
        /** */
        ...mapActions([
            'fetchUser',
            'fetchDeparts',
            'fetchTransTypes'
        ]),
        /********************************/
        /* */
        setDates(){
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            const day = currentDate.getDate();
            const monthAgoDate = new Date(year, month - 1 , day + 1);
            // If the day rolled over to the next month (e.g., Feb 31 becomes Mar 2), fix it
            if(monthAgoDate.getMonth() === month) {
                monthAgoDate.setDate(1);
            }
            this.searchData.from = monthAgoDate.toISOString().split('T')[0]
            this.searchData.to = currentDate.toISOString().split('T')[0];
        },
        /********************************/
        /* */
        async fetchOptions() {
            if (this.getDeparts.length == 0) {
                await this.fetchDeparts();
            }
            if (this.getUser.hasOwnProperty("empNo") == 0) {
                await this.fetchUser();
            }
            if (this.getTransTypes.length == 0) {
                await this.fetchTransTypes();
            }
            this.departs = (this.getDeparts[0].id == 1) ? this.getDeparts.slice(1) : this.getDeparts;
        },
        /********************/
        /* */
        resetValues() {
            this.reportData={};
            this.searchData.pageNo = 1;
        },
        /********************/

        // Fetch the report data with pagination for each section
        async getReport() {
            this.searchData.pageNo = 1;
            try {
                const response = await this.$axios.post(this.endPoints[this.searchData.type], this.searchData );

                if (response?.data && response?.data.isSuccess) {
                    // Update the reportData with pagination information for each section
                    this.reportData = response.data.data;
                    // كان هكذا قبل إضافة خيار المعبر الحدودي لمدير النظام
                    // this.reportData = response.data.data.map(section => ({
                    //     ...section,
                    //     pageNo: section.pageNo || 1,
                    //     totalPages: section.totalPages || 1,
                    // }));
                } else {
                    this.$tempAlert(response?.data.msg ?? "حدثت مشكلة", 'warning');
                    this.reportData = {};
                }
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },

        // Change the current page for a specific report section
        changePage(reportAppSection, newPageNo) {
            if (newPageNo >= 1 && newPageNo <= reportAppSection.totalPages) {
                reportAppSection.pageNo = newPageNo;
                this.getReportForSection(reportAppSection);
            }
        },

        // Fetch the report for a specific section based on the page number
        async getReportForSection(reportAppSection) {
            this.searchData.pageNo = reportAppSection.pageNo
            try {
                const response = await this.$axios.post(this.endPoints[this.searchData.type], this.searchData);
                this.reportData = response.data.data;
            } catch (error) {
                console.error("Error fetching report for section:", error);
            }
        },

        /** */
        // Fetch the report as a pdf file
        async printPdf() {
            this.searchData.pageNo = 1;
            try {
                const response = await this.$axios.post( this.printEndPoints[this.searchData.type], this.searchData,
                    {
                        responseType: 'blob',
                    });

                console.log(response)

                const blob = new Blob([response.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)

                // Open in a new tab
                window.open(url, '_blank')

                // Optional cleanup (after some delay to let the file load)
                setTimeout(() => {
                    window.URL.revokeObjectURL(url)
                }, 100)
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },
    }
}
</script>
